<template>
  <div>
    <!-- LIST START -->
    <template>

      {{compText}}
      <v-list dense rounded three-line class="mx-auto" tile max-width="300">
          <v-list-item-group   color="orange" v-model="selectedListItem">
            <!-- <v-divider :key="i" inset="true" v-if="i>0"></v-divider> -->
            <v-list-item v-for="(item, i) in items" :key="i" @click="setSelectedItem(item)" >
              <!-- <v-list-item-icon>
                <v-icon small>mdi-chevron-double-left</v-icon>
              </v-list-item-icon> -->
              <v-list-item-content :color="item.Color">
                <v-row align="center">
                  <v-col>
                    <v-list-item-title v-text="item.Name"></v-list-item-title>
                    <v-list-item-subtitle
                      v-text="item.CommentTemplate"
                    ></v-list-item-subtitle>
                  </v-col>
                </v-row>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
      </v-list>
    </template>
  </div>
</template>



<!-- LIST SLUTT -->


<script>
import axios from "axios";

export default {
  name: "CommentTemplate",
  //   props: ["myProp"], //Single prop
  props: {
    id: Number,
    text: String, //from view
  },
  data() {
    return {
      //data
      items: [],
      currentitems: [],
      //selected item from data
      selectedItem: [],
      selectedCommentText: null,
      //
      errors: [],
      cancellink: { to: "/events" },
      isValid: true,
      //selected list item
      selectedListItem: -1,
      compId: this.id,
      compText: this.text,
      eventId: this.id,
    };
  },

  created() {
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    // this.baseUrl = "http://localhost:3000/dbapi/";
    this.selectedCommentText = "Not selected";
    this.getCookies();
    // this.eventId = 2;
    this.getdata(this.compId);
    this.loading = false;
  },

  methods: {
    showAlert(a) {
      alert("Alert! \n" + a);
    },
    setSelectedItem(item) {
      this.selectedItem = item;
      // this.selectedCommentText = item.Event;
      this.$emit("comment_changed", item);
    },
    getdata(eventId) {
      var apimethod = "geteventcommenttemplates";
      var uri = this.baseUrl + apimethod + "/" + eventId;
      this.get(uri, apimethod);
    },
    getCookies() {
      this.cookieRegId = this.$cookies.get("pgbregid");
      this.cookieToken = this.$cookies.get("pgbtoken");
      this.cookiePilotName = this.$cookies.get("pgbname");
      this.regId = this.cookieRegId;
      this.ac = this.cookieToken;
      if (this.cookieToken > 0) {
        this.loggedIn = true;
      }
    },
    get(uri, apimethod) {
      axios
        .get(uri)
        .then((response) => {
          this.currentitems = response.data;
          this.loading = false;
          console.log(this.currentitems);
          this.setdataarray(apimethod);
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    setdataarray(apimethod) {
      if (apimethod == "geteventcommenttemplates") {
        this.items = this.currentitems;
      }
    },
  },
};
</script>
